module.exports = __webpack_public_path__ + "wxres/vue/img/padcontrol_home.6a2d8ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padcontrol_home.png
// module id = H6I6
// module chunks = 59 60 62 63 64 65 66 67 68 69 70 71 72 73 74 75 76 77 78 79 80 81 82